


































import { Ref, ref } from "vue-demi";
import BaseTable from "./BaseTable.vue";
import {
  MiddlemenListQuery,
  useMiddlemenListQuery,
} from "@/graphql/listQueries";
import { useResult } from "@vue/apollo-composable";
import router from "@/router";
import DeleteMiddlemanDialog from "../Dialogs/DeleteMiddlemanDialog.vue";
import EditMiddlemanDialog from "../Dialogs/EditMiddlemanDialog.vue";

export default {
  components: {
    BaseTable,
    DeleteMiddlemanDialog,
    EditMiddlemanDialog,
  },
  props: {
    user: {
      type: Object,
    },
  },
  setup(props) {
    const table = ref(null);

    return {
      table,
      headers: [
        {
          text: "Aktualizované",
          value: "UpdatedAt",
          sortable: true,
          searchable: false,
          width: "20%",
        },
        {
          text: "Meno",
          align: "start",
          value: "Name",
          searchable: true,
        },
        { text: "Popis", value: "Note", searchable: true },
        { text: "Profesia", value: "Profession", searchable: true },
        { text: "Typ", value: "Type", searchable: true },
        { text: "", value: "actions", sortable: false },
      ],

      useMiddlemenQuery: useMiddlemenListQuery,
      itemsGetter: (result: Ref<MiddlemenListQuery>) =>
        useResult(result, [], (d) => d.middlemen.nodes),
      totalCountGetter: (result: Ref<MiddlemenListQuery>) =>
        useResult(result, 0, (d) => d.middlemen.totalCount),
      reloadTable: () => (table as any).value.reload(),
      onRowClick: (item) =>
        router.push({ name: "MiddlemanDetail", params: { id: item.Id } }),
    };
  },
};
